package org.dronda.app.web.repository.util

import kotlinx.browser.window
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonNames
import kotlin.io.encoding.ExperimentalEncodingApi
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

private val json = Json { ignoreUnknownKeys = true }
@OptIn(ExperimentalEncodingApi::class)
fun decodeClaims(token: String): JwtToken? {
    return runCatching {
        val encodedPayload = token.substringAfter(".").substringBefore(".")
        json.decodeFromString<JwtToken>(
            window.atob(encodedPayload)
//            Base64.decode(encodedPayload).decodeToString()
        )
    }.getOrNull()
}


@Serializable
data class JwtToken @OptIn(ExperimentalSerializationApi::class) constructor(
    @JsonNames("https://dronda.org/clientUuid")
    val clientUuid: String,
    @JsonNames("https://dronda.org/clientId")
    val clientId: String,
    val exp: Long?,
)

@OptIn(ExperimentalTime::class)
val JwtToken.isExpired: Boolean
    get() = this.exp?.let { Instant.fromEpochSeconds(exp) <= Clock.System.now() } == true
